import { render, staticRenderFns } from "./pt-register.vue?vue&type=template&id=5f4b84c4&"
import script from "./pt-register.vue?vue&type=script&lang=js&"
export * from "./pt-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports